import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Link from 'next/link';
export default function Footer() {
  return /*#__PURE__*/_jsx("footer", {
    className: "border-t bg-accent-1 border-accent-2",
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col items-center justify-evenly py-14 lg:flex-row",
      children: [/*#__PURE__*/_jsx("h3", {
        className: "mb-10 text-4xl font-bold leading-tight tracking-tighter text-center lg:text-5xl lg:text-left lg:mb-0 lg:pr-4",
        children: "Blog"
      }), /*#__PURE__*/_jsx("div", {
        className: "flex flex-col items-center justify-center lg:flex-row lg:pl-4",
        children: /*#__PURE__*/_jsx(Link, {
          href: "https://docs.yalendar.com/",
          passHref: true,
          children: /*#__PURE__*/_jsx("a", {
            className: "px-12 py-3 mx-3 mb-6 font-bold text-white transition-colors duration-200 bg-black border border-black hover:bg-white hover:text-black lg:px-8 lg:mb-0",
            children: "Yalendar docs"
          })
        })
      })]
    })
  });
}